import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { useResponsive } from '@sg/garnish';

import { Address, useAddressHandlers as useAddressHandlersV2 } from '@order/features-locations';

import { useCustomer } from '../../context';
import { Modal } from '../Modal';

export const AddressAddModal = (props: AddressAddModalProps) => {
  const { visible, onRequestClose } = props;

  // ─────────────────────────────────────────────────────────────────────────────

  const { customer } = useCustomer();
  const customerAddresses = customer?.addresses ?? [];

  const { formatMessage } = useIntl();
  const { match } = useResponsive();

  const { handleOnSave: handleOnSaveV2, isAddingAddress: isAddingAddressV2 } = useAddressHandlersV2(
    { onSuccess: onRequestClose },
  );

  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <Modal
      fitHeight
      visible={visible}
      accessibilityLabel={formatMessage(messages.modalHeadline)}
      presentationStyle="pageSheet"
      size={match(['full', 'small'])}
      onRequestClose={onRequestClose}
    >
      <Modal.Header onClose={onRequestClose}>
        <FormattedMessage {...messages.modalHeadline} />
      </Modal.Header>

      <Address.Form
        visible={visible}
        customerAddresses={customerAddresses}
        onSubmit={handleOnSaveV2}
        isLoading={isAddingAddressV2}
      />
    </Modal>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  saveAddress: {
    defaultMessage: 'Save',
    description: 'Account | Add Address Form | Save',
  },
  modalHeadline: {
    defaultMessage: 'Add Address',
    description: 'Account | Modal header | Add Address',
  },
});

// ─── Types ─────────────────────────────────────────────────────────────

type AddressAddModalProps = Readonly<{
  visible: boolean;
  onRequestClose: () => void;
}>;
